import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { appStateProvider } from '../../insa-providers';
import { AuthService, PartnerEmailService } from '../../insa-services';
import { PartnerEmailModel } from '../../insa-models';
import { SharedMethodsModule } from '../../insa-custom-scripts';

type PartnersList = { partnerIndex: string, partnerNumber: string }[];

@Component({
  template:
    '<div class="canvas gridResize"><div id="TestGrid" class="testGrid-loading" style="min-height: 100%"></div></div>',
})
export class EmailMapperComponent implements AfterViewInit, OnDestroy {
  private partnerEmailSubscription;
  private userInfoSubscription;
  private appStateSubscription;

  private partnersList: PartnersList = [];

  constructor(private _partnerEmailService: PartnerEmailService, private _appStateProvider: appStateProvider, private _authService: AuthService) {
    if (!_appStateProvider.fetchingPartnerEmails) {
      if (!_partnerEmailService.partnerEmails) {
        _partnerEmailService.getPartnerEmails();
      }
    }

    this.userInfoSubscription = _authService.UserInfoEmitter.subscribe(userInfo => {
        this.partnersList = this.partnersListToArray(userInfo.PartnersList)
        this.refreshPartnerEmails(_partnerEmailService.partnerEmails);
    })

    if (_authService.UserInfo) this.partnersList = this.partnersListToArray(_authService.UserInfo.PartnersList)

    this.partnerEmailSubscription = this._partnerEmailService.PartnerEmailsChangedEvent.subscribe(partnerEmails => {
      if (this._authService.UserInfo) this.refreshPartnerEmails(partnerEmails);
    });

    this.appStateSubscription = _appStateProvider.subscribe(() => {
      this.refreshPartnerEmails(_partnerEmailService.partnerEmails);
    })


  }

  partnersListToArray(PartnersList): PartnersList {
    return Object.keys(PartnersList).map(key => {
      return {
        partnerIndex: key,
        partnerNumber: PartnersList[key]
      }
    }).concat({
      partnerIndex: null,
      partnerNumber: ""
    })
  }

  private refreshPartnerEmails(partnerEmails) {
    kendo.ui.progress($(".testGrid-loading"), (this._appStateProvider.fetchingPartnerEmails || this.partnersList.length < 1));
    if (partnerEmails !== undefined && partnerEmails !== null && partnerEmails.length > 0 && this.partnersList.length > 0) {
      this.InitKendoEmailMapperGrid(partnerEmails);
    } else {
      this.InitKendoEmailMapperGrid([]);
    }
  }

  sortPartnersByName(arr) {
    return arr.sort((a, b) => {
      if (a.partnerNumber > b.partnerNumber) return 1;
      else if (a.partnerNumber < b.partnerNumber) return -1;
      else return 0;
    });
  }

  findPartnerByIndex(partnerIndex) {
    return this.partnersList.find(p => p.partnerIndex == partnerIndex)
  }

  InitKendoEmailMapperGrid(gridData) {
    console.log('dates')
    console.log(this._appStateProvider.startDate, this._appStateProvider.endDate)
    let dataSource = new kendo.data.DataSource({
      data: gridData,
      sort: this.getSortSettings(),
      filter: (this._appStateProvider.startDate && this._appStateProvider.endDate) ? [
        {
          field: 'EmailDate',
          operator: "gte",
          value: this._appStateProvider.startDate
        },
        {
          field: 'EmailDate',
          operator: "lte",
          value: this._appStateProvider.endDate
        }
      ] : undefined,
      autoSync: true,
      schema: {
        model: {
          fields: {
            EmailDate: {
              type: "date",
              editable: false,
            },
            Subject: {
              type: "string",
              editable: false
            },
            EmailFrom: {
              type: "string",
              editable: false,
            },
            PartnerIndex: {
              type: "string",
              editable: true
            },
          },
        },
      },
    } as kendo.data.DataSourceOptions);

    let emailMapperGrid: kendo.ui.Grid = $("#TestGrid").data("TestGrid");

    if (emailMapperGrid === undefined) {
      let emailMapperGridOptions: kendo.ui.GridOptions = {
        dataSource: dataSource,
        sortable: true,
        scrollable: true,
        editable: true,
        filterable: true,
        reorderable: true,
        resizable: true,
        filter: (e) => {console.log(e)},
        noRecords: {
          template: SharedMethodsModule.noDataTemplate()
        },
        sort: function (evt) {
          if (evt.sort !== undefined && evt.sort !== null) {
            try {
              localStorage.setItem(
                "emailMapperGridSorting",
                JSON.stringify(evt.sort)
              );
            } catch (err) {
              console.error(err);
            }
          }
        },
        columns: [
          {
            field: "EmailDate",
            title: "Date",
            filterable: false,
            template: '#: (EmailDate!==null)? kendo.toString(EmailDate, "dd.MM.yyyy"): ""#',
          },
          {
            field: "Subject",
            title: "Subject",
          },
          { field: "EmailFrom", title: "From" },
          {
            field: "PartnerIndex",
            title: "Assigned",
            editor: this.partnerIndexEditor.bind(this),
            template: ((model) => {
              if (model.PartnerIndex) { 
                return this.findPartnerByIndex(model.PartnerIndex) ? this.findPartnerByIndex(model.PartnerIndex).partnerNumber : '[unknown]'
              }
              return ''
            }).bind(this),
          },
        ]
      };

      $("#TestGrid").kendoGrid(emailMapperGridOptions);
      emailMapperGrid = $("#TestGrid").data("kendoGrid");
    } else {
      emailMapperGrid.setDataSource(dataSource);
    }
  }

  getSortSettings() {
    const defaultSettings = {
      field: "PartnerIndex",
      dir: "asc",
    };
    let storedSettings;

    try {
      storedSettings = localStorage.getItem("emailMapperGridSorting");
    } catch (err) {
      console.warn(err);
    }

    if (storedSettings) return JSON.parse(storedSettings);
    return defaultSettings;
  }

  partnerIndexEditor(container, options) {
    $(`<span id=${options.field} name="${options.field}"></span>`)
      .appendTo(container)
      .kendoComboBox({
        dataSource: this.sortPartnersByName(this.partnersList),
        autoBind: false,
        filter: "contains",
        dataTextField: "partnerNumber",
        dataValueField: "partnerIndex",
        value: options.model.PartnerIndex,
        change: (evt) => {
          console.log(options)
          const val = evt.sender.value() || null
          if (val != options.model.PartnerIndex) {
            const model = options.model as PartnerEmailModel
            const newEmail: PartnerEmailModel = {
              ID: model.ID,
              Body: model.Body,
              EmailDate: model.EmailDate,
              EmailFrom: model.EmailFrom,
              EmailTo: model.EmailTo,
              PartnerIndex: val,
              Subject: model.Subject
            }
            this._partnerEmailService.UpdatePartnerEmail(newEmail);
          }
        },
      });
  }

  ngAfterViewInit() {
    if (this._partnerEmailService.partnerEmails !== undefined && this._partnerEmailService.partnerEmails !== null) {
      this.refreshPartnerEmails(this._partnerEmailService.partnerEmails);
    }
  }

  ngOnDestroy () {
    this.partnerEmailSubscription.unsubscribe();   
    this.userInfoSubscription.unsubscribe();
    this.appStateSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-grids/email-mapper.component.ts